module.exports = __webpack_public_path__ + "media/images/flags/BY-8c6b00ed6d84c83a0a5bac10783bacf9.svg";